// rem 单位应用
(function (win) {
  let ratio; let scaleValue; let renderTime;
  const { document } = window;
  const docElem = document.documentElement;
  let vpm = document.querySelector('meta[name="viewport"]');
  if (vpm) {
    const tempArray = vpm.getAttribute('content').match(/initial-scale=(["']?)([\d.]+)\1?/);
    if (tempArray) {
      scaleValue = parseFloat(tempArray[2]);
      ratio = parseInt(1 / scaleValue, 0);
    }
  } else {
    vpm = document.createElement('meta');
    vpm.setAttribute('name', 'viewport');
    vpm.setAttribute('content', 'width=device-width,initial-scale=1,user-scalable=no,minimal-ui');
    docElem.firstElementChild.appendChild(vpm);
  }

  win.addEventListener('resize', () => {
    clearTimeout(renderTime);
    renderTime = setTimeout(initPage, 300);
  }, false);

  win.addEventListener('pageshow', (e) => {
    e.persisted && (clearTimeout(renderTime), renderTime = setTimeout(initPage, 300));
  }, false);

  'complete' === document.readyState ? document.body.style.fontSize = `${12 * ratio}px`
    : document.addEventListener('DOMContentLoaded', () => {
      document.body.style.fontSize = `${12 * ratio}px`;
    }, false);
  initPage();
  function initPage() {
    let htmlWidth = docElem.getBoundingClientRect().width;
    if (htmlWidth > 640) htmlWidth = 640;
    htmlWidth / ratio > 640 && (htmlWidth = 640 * ratio);
    win.rem = htmlWidth / 16;
    docElem.style.fontSize = `${win.rem}px`;
  }
}(window));



// WEBPACK FOOTER //
// ./src/js/rem.js